import { Clock4 } from 'lucide-react';
import { useDrag } from 'react-dnd'

const ProjectBlobNarrow = (props) => {
    
    var local = new Date(props.project.due_date);
    var offset = local.getTimezoneOffset();
    var due_date = new Date(local.getTime() + offset * 60000);

    function convertCurrencyToDouble(currency, locale = 'en-US', currencyType = 'USD') {
        // Creating a NumberFormat object with specified locale and currency
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyType,
            currencyDisplay: 'symbol'
        });
    
        // Formatting the currency to remove any non-numeric characters except for decimal point
        const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
    
        // Converting the normalized string to a double value using Number constructor
        const doubleValue = Number(normalizedCurrency);
    
        // Returning the double value
        return doubleValue;

    }



    const fee = convertCurrencyToDouble(props.project.fee)
    const paid = convertCurrencyToDouble(props.project.paid)

    // console.log(props.project)
    const name = props.project.title
    const id = props.project.id
    const project = props.project
    const [{ isDragging }, dragRef] = useDrag({
        type: 'project',
        item: { project },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    })

    let statusColor = (function () {
        switch (props.project.status){
            case "Not Started":
                return "not_started"
                break;
            case "Awaiting Assets":
                return "assets"
                break;
            case "In Progress":
                return "wip"
                break;
            case "Awaiting Feedback":
                return "feedback"
                break;
            case "Revising":
                return "revising"
                break;
            case "Mastering":
                return "mastering"
                break;
            case "Delivering":
                return "delivering"
                break;
            case "Complete":
                return "complete"
                break;
            default:
                return ""
        }
    })();

    const blobBaseClasses = "projectBlobNarrow rounded-lg px-5 py-2 hoverLeft"
    const activeBlobClasses = isDragging ? "text-white" : "gradientWhite text-black"

    return (

        // <div className="projectBlobNarrow gradientWhite rounded-lg px-5 py-2 text-black hoverLeft" ref={dragRef}>
        <div className={`${blobBaseClasses} ${activeBlobClasses}`} ref={dragRef}>
            {/* <div className="flex flex-row items-center"> */}
                <div className="grid grid-cols-7  text-xs items-center">
                    <span className='text-[#444] font-semibold uppercase col-span-2 pr-1 overflow-hidden text-nowrap text-ellipsis'>
                        {props.project.client}
                    </span>
                    <h4 className="text-black col-span-2 overflow-hidden text-nowrap text-ellipsis">
                        {props.project.title}
                    </h4>
                    {paid>=fee ? 
                        <div className="w-fit bg-[#007100] text-[8px] text-white uppercase font-semibold rounded-lg px-1 m-auto tracking-wider" id=""> 
                            Paid
                        </div>
                        : 
                        <div className='col-span-1'></div> 
                    }
                    <div className="text-[8px] font-semibold text-nowrap text-[#555] col-span-2">
                        &nbsp; Due  {due_date.toDateString()}
                    </div>
                </div>

            {/* </div> */}
            {/* {isDragging && '😱'} */}
        </div>
    )
}

export default ProjectBlobNarrow